export const REPORT_CONTROL_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  INTEGER: 'integer',
  DATE: 'date',
  SELECT: 'select',
  SELECT_DROPDOWN: 'select_dropdown',
  MULTI_SELECT: 'multi_select',
  MEASUREMENT: 'measurement',
  PHOTO: 'photo',
  GROUP: 'group',
  EDITABLE_ENTRY_LIST: 'editable_entry_list',
} as const

export type ControlType =
  (typeof REPORT_CONTROL_TYPES)[keyof typeof REPORT_CONTROL_TYPES]
